export async function getHubMessages(request: any, service: Xplor.Service) {
  const response = await request.get(`/api/parent/messages/${service.id}`)

  return response && response.data ? response.data : []
}
